import React from 'react'
import { Box } from '@mui/material'
import { Check, DoneAll, Schedule, ErrorOutline } from '@mui/icons-material'
import { getSafeMessageStatus, getStatusColor, MessageWithStatus } from '../../utils/messageStatus'

interface MessageStatusIconProps {
  message: MessageWithStatus
}

const MessageStatusIcon: React.FC<MessageStatusIconProps> = ({ message }) => {
  // Only show for outbound messages
  if (message.direction !== 'outbound') return null

  const status = getSafeMessageStatus(message)
  const color = getStatusColor(status)

  const renderIcon = () => {
    switch (status) {
      case 'pending':
        return <Schedule sx={{ fontSize: 14, color }} />
      case 'sent':
        return <Check sx={{ fontSize: 16, color }} />
      case 'delivered':
        return <DoneAll sx={{ fontSize: 16, color }} />
      case 'read':
        return <DoneAll sx={{ fontSize: 16, color }} />
      case 'failed':
        return <ErrorOutline sx={{ fontSize: 16, color }} />
      default:
        return null
    }
  }

  return (
    <Box sx={{ ml: 0.5, display: 'flex', alignItems: 'center' }}>
      {renderIcon()}
    </Box>
  )
}

export default React.memo(MessageStatusIcon, (prevProps, nextProps) => {
  // Custom comparison to check if status fields changed
  return (
    prevProps.message.id === nextProps.message.id &&
    prevProps.message.is_sent === nextProps.message.is_sent &&
    prevProps.message.is_delivered === nextProps.message.is_delivered &&
    prevProps.message.is_read === nextProps.message.is_read &&
    prevProps.message.is_failed === nextProps.message.is_failed
  )
})
